import { useCallback, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { Socket } from 'socket.io-client';
import { TRIP_GET_ONE } from 'api/query-keys';
import type { ITripInvalidateOneEvent } from './types';
import { ESocketEventName } from './types';

export const useHandleTripInvalidateOne = (socket: Socket) => {
  const queryClient = useQueryClient();

  const handler = useCallback(
    async (event: ITripInvalidateOneEvent) => {
      const tripId = event.payload.tripId;

      await queryClient.invalidateQueries([TRIP_GET_ONE, tripId]);
    },
    [queryClient],
  );

  useEffect(() => {
    socket.on(ESocketEventName.tripInvalidateOne, handler);

    return () => {
      socket.removeListener(ESocketEventName.tripInvalidateOne, handler);
    };
  }, [handler, socket]);
};
